
export const getGridDimensions = (imageCount: number): [number, number] => {
  if (imageCount <= 1) return [1, 1];
  if (imageCount <= 2) return [2, 1];
  if (imageCount <= 4) return [2, 2];
  return [3, 3];
};

export const loadImage = (file: File): Promise<HTMLImageElement> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.src = URL.createObjectURL(file);
  });
};
